export default function ExemptionCheckboxHidden({element, index, defaultChecked}) {
    return (
        <input
            key={index}
            name="ExemptionsList"
            type="checkbox"
            value={index}
            title={element.exemption_label}
            hidden
            alwayshidden="true"
            defaultChecked={defaultChecked}
        />
    )
}